import { gql } from '@apollo/client'

export const Query = gql`
  query EditMultiplierType($companyId: ID!, $filters: MultiplierTypeFilters) {
    multiplierTypes(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        multiplier
        multiplierType
        operandQuantity
        operandType
      }
    }
  }
`
